import type { RecoverPasswordApiCreationQuery } from "@/Modules/Models/Api/Auth";
import type { RecoverPasswordCreationQuery } from "@/Modules/Models/Domain/Auth";
import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import { recoverPassword } from "@/Services/TherapyApi/Auth";

import { useAuthStore } from "@/Modules/Auth/Store";

async function recoverPasswordAH(recoverPasswordCreationQuery: RecoverPasswordCreationQuery): Promise<void> {
  const authStore = useAuthStore();
  const recoverPasswordApiCreationQuery: RecoverPasswordApiCreationQuery = {
    email: recoverPasswordCreationQuery.email,
  };

  try {
    await recoverPassword(recoverPasswordApiCreationQuery);

    authStore.notification = {
      type: NotificationType.SUCCESS,
      code: null,
      message: "recover_password_process_in_progress",
    };
  } catch (error: unknown) {
    authStore.notification = {
      type: NotificationType.SUCCESS,
      code: null,
      message: "recover_password_process_in_progress",
    };
  } finally {
    authStore.isLoading = false;
  }
}

export default recoverPasswordAH;
